import React from "react";

import { connect } from "../i18n/connect";
import { resolveIsPasswordLogin } from "../lib/auth/authLoginPageTypes";
import {
  authCheckboxLabelClassName,
  authCheckboxLabelStyle,
  authCheckboxLabelTagsStyles
} from "../lib/auth/authCheckboxLabelStyles";
import {
  authCurrentPasswordInputProps,
  authUsernameOrEmailInputProps
} from "../lib/auth/authAutofillHints";
import { actions as authActions } from "../redux/modules/auth/login";
import { getAuthLoginLoading } from "../redux/modules/authLoginLoading/selector";
import { otpRequestRoutine } from "../redux/modules/auth/register";
import { getOtpRequestLoading } from "../redux/modules/auth/register/selector";
import withFormBuilder from "./withFormBuilder";

const userField = {
  name: "user",
  label: "User name or email",
  type: "newText",
  required: true,
  fullWidth: true,
  validationErrors: {
    isDefaultRequiredValue: "This field is required"
  },
  value: "",
  ...authUsernameOrEmailInputProps,
  wrapperClassName: "mb-4",
  nativeStyles: { marginBottom: 24 }
};

const otpUserField = {
  name: "user",
  label: "User name or email",
  type: "newText",
  required: true,
  fullWidth: true,
  validationErrors: {
    isDefaultRequiredValue: "This field is required"
  },
  value: "",
  ...authUsernameOrEmailInputProps,
  wrapperClassName: "mb-4",
  nativeStyles: { marginBottom: 24 }
};

const passwordFields = [
  userField,
  {
    name: "password",
    value: "",
    type: "newText",
    inputType: "password",
    required: true,
    fullWidth: true,
    validationErrors: {
      isDefaultRequiredValue: "This field is required"
    },
    label: "Password",
    ...authCurrentPasswordInputProps,
    wrapperClassName: "mb-4",
    nativeStyles: { marginBottom: 16 }
  },
  {
    name: "rememberme",
    selected: [],
    type: "newCheckbox",
    options: [
      {
        label: "Remember me",
        value: "rememberme"
      }
    ],
    labelClassName: authCheckboxLabelClassName,
    labelStyle: authCheckboxLabelStyle,
    labelTagsStyles: authCheckboxLabelTagsStyles
  }
];

const otpFields = [otpUserField];

const mapStateToProps = state => ({
  loginLoading: getAuthLoginLoading(state),
  otpRequestLoading: getOtpRequestLoading(state)
});

const mapDispatchToProps = {
  login: authActions.login,
  otpRequest: otpRequestRoutine.trigger
};

export default function withLoginForm(WrappedComponent) {
  const PasswordForm = withFormBuilder(passwordFields)(WrappedComponent);
  const OtpForm = withFormBuilder(otpFields)(WrappedComponent);

  @connect(mapStateToProps, mapDispatchToProps)
  class WithLoginForm extends React.Component {
    render() {
      const search = this.props.location?.search || "";
      const routeParams = this.props.loginRouteParams || {};
      const isPasswordLogin =
        this.props.isPasswordLogin ??
        resolveIsPasswordLogin({ search, routeParams });
      const Component = isPasswordLogin ? PasswordForm : OtpForm;

      return <Component {...this.props} isPasswordLogin={isPasswordLogin} />;
    }
  }

  return WithLoginForm;
}
